import React from 'react';
import PropTypes from 'prop-types';
import { FDPaper, FDStack } from '@facet-wealth/design';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import MuiDrawer from '@mui/material/Drawer';
import { EstatePlanningManagementPageStep } from './EstatePlanningManagementPageStep';

export const EstatePlanningManagementPageSteps = ({ collection }) => {
  const isMobile = useMobileLayout();

  const theme = useTheme();
  const [activeStep, activeStepIdx] = React.useMemo(() => {
    return collection.resources().list().reduce((acc, curr, i) => {
      if (curr.isTruthy('isActive')) {
        return [curr, i];
      }
      return acc;
    }, [null, null]);
  }, [collection]);

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  if (isMobile) {
    return (<>
      <MuiDrawer open={drawerOpen} anchor={'bottom'} onClose={() => setDrawerOpen(false)}>
        <FDPaper width={'100%'} padding={4} appearance={'elevated'}>
          <EstatePlanningManagementPageStep
            stepResource={activeStep}
            currStep={activeStepIdx + 1}
            totalSteps={collection.resources().length()}
          />
        </FDPaper>
      </MuiDrawer>
      <FDStack justifyContent={'center'} width={'100%'}>
        <FDPaper width={'100%'} padding={2} appearance={'elevated'} maxWidth={400}>
          <EstatePlanningManagementPageStep
            stepResource={activeStep}
            currStep={activeStepIdx + 1}
            totalSteps={collection.resources().length()}
          />
        </FDPaper>
      </FDStack>
    </>);
  }

  return (
    <div style={{ position: 'sticky', top: theme.heights.standardHeaderHeight + 32 }}>
      <FDPaper maxWidth={300} width={'100%'} padding={4} appearance={'elevated'}>
        <EstatePlanningManagementPageStep
          stepResource={activeStep}
          currStep={activeStepIdx + 1}
          totalSteps={collection.resources().length()}
        />
      </FDPaper>
    </div>
  );
};

EstatePlanningManagementPageSteps.propTypes = {
  collection: PropTypes.object.isRequired,
};
